import AsyncContent from "@magicware/dashboard/AsyncContent";
import DataList from "@magicware/data-lists/DataList";
import { FormStateApiContextProvider } from "@magicware/forms/components/FormStateApiContext";
import { useTranslation } from "react-i18next";
import { useAppInstaceNavigation, useAppInstanceId } from "../../navigation/appInstances";
import { appInstanceConnectionThunks, setPage } from "../../redux/appInstanceConnections/appInstanceConnectionsReducer";
import { useAutoDispatchAsyncThunk } from "../../redux/hooks";
import { RootState } from "../../redux/types";
import EntityListItemMenuContext from "../entities/EntityListItemMenuContext";
import AppInstanceConnectionListItem from "./AppInstanceConnectionListItem";
import AppInstanceConnectionListMenuContext from "./AppInstanceConnectionListMenuContext";

export default function AppInstanceConnectionListTab() {
    const appInstanceId = useAppInstanceId();
    const api = useAutoDispatchAsyncThunk(appInstanceConnectionThunks.loadList, { appInstanceId });
    return <AsyncContent {...api} component={AppInstanceConnectionListTabLoaded} />;
}

function AppInstanceConnectionListTabLoaded() {
    const { t } = useTranslation();
    const navigation = useAppInstaceNavigation();
    return (
        <FormStateApiContextProvider>
            <AppInstanceConnectionListMenuContext>
                <EntityListItemMenuContext
                    deleteSnackTitle={t("appInstanceConnection-deletion")}
                    deleteThunk={appInstanceConnectionThunks.delete}
                >
                    <DataList
                        dataSelector={(state: RootState) => state.appInstanceConnections.list}
                        setPageActionCreator={setPage}
                        emptyList={t("no-appInstanceConnections-message")}
                    >
                        {(id) => <AppInstanceConnectionListItem appInstanceConnectionId={id} navigation={navigation} />}
                    </DataList>
                </EntityListItemMenuContext>
            </AppInstanceConnectionListMenuContext>
        </FormStateApiContextProvider>
    );
}
